const _ = require('underscore');
var model = require('model/model');

/**
 * The student workspace results-tab.vue and questions-tab.vue share some logic
 * around navigating between question sets. Rather than copy & paste the shared
 * methods and computed properties have been moved here
 */
module.exports = {
	methods: {
		nextQuestionSet: function () {
			var current = this.qs.qsid;
			var qsets = this.questionSetsOrderedAndFiltered;
			for (var i = 0; i < qsets.length; i++) {
				var qs = qsets[i];
				if (qs.qsid === current) {
					var params = {};
					params[this.qsetTabKey] = qsets[(i + 1) % qsets.length].qsid;
					model.set(params);
				}
			}
		}
	},
	computed: {
		atLastQuestionSet: function () {
			var qso = this.questionSetsOrderedAndFiltered;
			return this.qs.qsid === qso[qso.length - 1].qsid;
		},
		qs() {
			const product = this.product;
			const qsets = product && product.questionSets;

			if (!qsets) {
				return null;
			}

			if (this.workspace.opts.qs.length > 1) {
				let key = this[this.qsetTabKey];
				if (!key) {
					key = this.workspace.opts.qs[0];
				}
				return qsets[key];
			} else {
				return qsets[this.workspace.opts.qs[0]];
			}
		},
		assignedQuestions() {
			const qs = this.qs;

			const isExpressQs = _.contains(this.workspace.opts.expressqs || [], qs.qsid);
			return this.product.getQuestions(qs.qsid, isExpressQs);
		}
	}
};
